// extracted by mini-css-extract-plugin
export default {"container":"FRiK+","isTop":"T3tnS","withPagination":"W1xPV","innerContainer":"_8jMgf","pagination":"OXiG5","arrow":"pFdjO","page":"mXazA","active":"jfmFQ"};